<template>
  <div class="account-register-check-email">
    <el-form
      ref="registerForm"
      :model="registerForm"
      :rules="registerRules"
      class="register-form"
      label-position="left"
    >
      <div v-show="!isSpecialTipCountry">
        <el-form-item prop="email" ref="emailFormItem">
          <template #label>
            <i class="icomoon-common_user" />
          </template>
          <email-input v-model="registerForm.email"></email-input>
        </el-form-item>
        <el-form-item prop="verifyCode" ref="verifyCodeFormItem" v-if="hideEmail">
          <template #label>
            <i class="icomoon-common_lock" />
          </template>
          <el-input
            v-model.trim="registerForm.verifyCode"
            :placeholder="$t('enter_img_verify_code')"
            class="login-code-input"
            v-input-limit
            data-input-type="alphanumeric"
            :maxlength="4"
            @keypress.enter.native="onGetEmailCode"
          ></el-input>
          <img :src="verifyImg" alt @click="changeCode" class="login-code-pic" crossorigin="anonymous">
          <div class="el-form-item__error my-false-item" v-if="verifyErrorTxt">{{ verifyErrorTxt }}</div>
        </el-form-item>
        <el-form-item prop="validateCode" ref="validateCodeFormItem" v-if="!hideEmail">
          <template #label>
            <i class="icomoon-common_lock" />
          </template>
          <el-input
            :maxlength="6"
            :placeholder="$t('enter_verify_code')"
            :tips="$t('v_code')"
            class="code-input"
            data-input-type="ten"
            v-input-limit
            v-model="registerForm.validateCode"
            @keypress.enter.native="onRegister"
          ></el-input>
          <el-button
            :disabled="isSendDisabled"
            @click="sendCode"
            class="code-button"
            type="link"
            v-loading="sendCodeBtnLoading"
            :max-width="135"
          >
            <span>{{ $t(getCodeText) }}</span>
            <span v-if="isSendDisabled">{{ countdownValue > 0 ? `(${countdownValue}s)` : '' }}</span>
          </el-button>
        </el-form-item>
        <el-button
          v-if="!hideEmail"
          :title="$t('no_email_code')"
          @click="showTips(0)"
          style="max-width: 342px"
          type="link"
        >
          {{ $t('no_email_code') }}
        </el-button>
      </div>
    </el-form>
    <template v-if="!isSpecialTipCountry">
      <el-button v-if="hideEmail" type="primary" class="entry-button" @click="onGetEmailCode" :title="$t('get_code')">
        {{ $t('get_code') }}
      </el-button>
      <el-button
        v-else
        type="primary"
        class="entry-button"
        @click="onRegister"
        :disabled="hideEmail"
        v-loading="btnLoading"
        :title="$t('btn_check_email')"
      >
        {{ $t('btn_check_email') }}
      </el-button>
    </template>
    <div class="special-country" v-else>
      <i class="icomoon-common_alert_hint_sm" />
      <span :title="$t('not_support_in_your_region')" class="text">{{ $t('not_support_in_your_region') }}</span>
    </div>
    <!-- 邮箱验证码和认证码提示框组件 -->
    <register-tips ref="RegisterTips" :type="0" :is-special-tip-country="false" :email="registerForm.email" />
  </div>
</template>

<script>
import RegisterTips from '@/Common/components/register-tips.vue';
import EmailInput from '@/Common/components/email-input';
import getInitLocale from '@pro/common/utils/getInitLocale';

export default {
  name: 'AccountRegisterCheckEmail',
  components: {
    RegisterTips,
    EmailInput
  },
  props: {
    autoEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hideEmail: true,
      verifyImg: '',
      sendCodeBtnLoading: false,
      isSendDisabled: false,
      countdownValue: 60, // 发送验证码按钮倒计时时间显示（秒）
      getCodeText: 'get_code',
      verifyErrorTxt: '', // 用于提示图形验证码相关报错
      registerForm: {
        verifyCode: '', //图形验证码
        email: '',
        validateCode: '',
        country: 0
      },
      btnLoading: false
    };
  },
  computed: {
    registerRules() {
      return {
        email: [
          { type: 'string', required: true, message: this.$t('v_not_empty') },
          { type: 'string', required: true, pattern: /\S/, message: this.$t('v_not_only_include_space') },
          {
            type: 'string',
            required: true,
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: this.$t('v_email_64')
          }
        ],
        validateCode: [
          { type: 'string', required: true, message: this.$t('v_not_empty') },
          { type: 'string', required: true, pattern: /\S/, message: this.$t('v_not_only_include_space') },
          { validator: this.validateEmailCode, trigger: 'blur' }
        ]
      };
    },
    isSpecialTipCountry() {
      return false; //TODO US [23].includes(this.getCountryOrRegionIndex());
    }
  },
  watch: {
    autoEmail(value) {
      if (value) {
        this.registerForm.email = value;
      }
    },
    'registerForm.email'() {
      this.verifyErrorTxt = '';
      this.$refs.validateCodeFormItem?.resetValidate();
    },
    'registerForm.validateCode'() {
      this.$refs.validateCodeFormItem?.resetValidate();
    }
  },
  created() {
    this.changeCode();
    if (this.autoEmail) {
      this.registerForm.email = this.autoEmail;
    }
    this.registerForm.country = this.getCountryOrRegionIndex();
  },
  methods: {
    changeCode() {
      this.verifyImg = `/hpp/company/security/v1/captcha?type=1&${ new Date().getTime()}`;
    },
    resetRegisterForm() {
      this.changeCode();
      this.registerForm = {
        verifyCode: '', //图形验证码
        email: '',
        validateCode: '',
        country: 0
      };
      this.hideEmail = true;
    },
    sendCode() {
      this.registerForm.verifyCode = '';
      this.changeCode();
      this.hideEmail = true;
    },
    initCodeBtn() {
      this.isSendDisabled = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 获取验证码信息提示弹出框
    showTips() {
      this.$bury.registerDialog(4); // 点击验证码未收到埋点
      this.$refs.RegisterTips.dialogVisible = true;
    },
    validateEmailCode(rule, value, callback) {
      if (value === '') {
        return callback();
      }

      if (value.length !== 6) {
        return callback(new Error(this.$t('only_6_num')));
      }
      return callback();
    },
    async onGetEmailCode() {
      // 判断是否填写图形验证码
      if (!this.registerForm.verifyCode) {
        this.showVerifyCodeError = true;
        this.verifyErrorTxt = this.$t('v_not_empty');
        return;
      }
      this.verifyErrorTxt = '';
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          const params = {
            lang: (getInitLocale() || 'en') === 'in' ? 'id' : (getInitLocale() || 'en'),
            email: this.registerForm.email,
            verifyCode: this.registerForm.verifyCode
          };

          if (this.getCodeText === 'send_again') {
            this.$bury.registerDialog(3); // 重新获取验证码埋点
          } else {
            this.$bury.registerDialog(2); // 获取验证码埋点
          }
          this.sendCodeBtnLoading = true;
          const [data, err] = await this.$api.getNewVerifyCodeCheck(params).catch((error) => {
            this.$bury.statisticsRegistrationRate(2, 1, error.response.status);
          });
          this.initCodeBtn();
          if (data) {
            this.$bury.statisticsRegistrationRate(2, 1);
            this.hideEmail = false;
            this.verifyErrorTxt = '';
            this.getCodeText = 'send_again';
            this.$message.success(this.$t('send_code_success'));
            this.countdownValue = data.retryTime || 60; // 倒计时时间
            this.isSendDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdownValue <= 0) {
                this.initCodeBtn();
              }
              this.countdownValue--;
            }, 1000);
          }
          if (err) {
            this.$bury.statisticsRegistrationRate(2, 1, err.errorCode);
            this.hideEmail = true;
            this.changeCode();
            this.verifyErrorTxt = this.$t(err.errorCode || 'verify_code_error');
            if (err.data && err.data.retryTime) {
              this.getCodeText = 'send_again';
              this.countdownValue = err.data.retryTime;
              this.isSendDisabled = true;
              this.timer = setInterval(() => {
                if (this.countdownValue <= 0) {
                  this.initCodeBtn();
                }
                this.countdownValue--;
              }, 1000);
            }
          }
          this.sendCodeBtnLoading = false;
        }
      });
    },
    async onRegister() {
      if (this.hideEmail) {
        return;
      }
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          if (this.hideEmail) {
            return;
          }
          const params = {
            email: this.registerForm.email,
            validateCode: this.registerForm.validateCode
          };
          this.btnLoading = true;
          const [, err] = await this.$api.emailVerifyCodeCheck(params).catch((error) => {
            this.btnLoading = false;
            this.$bury.statisticsRegistrationRate(2, 2, error.response.status);
          });
          if (!err) {
            this.loginAsTourist(this.getCountryOrRegionIndex()).finally(() => {
              this.btnLoading = false;
            });
            this.$bury.registerDialog(5, 1);
            this.$bury.statisticsRegistrationRate(2, 2);
          } else {
            this.btnLoading = false;
            this.$bury.registerDialog(5, 2);
            this.$bury.statisticsRegistrationRate(2, 2, err.errorCode);
          }
        }
      });
    },
    async loginAsTourist(countryIndex) {
      const data = {
        companyType: 1,
        installerId: 'ff8080816e6e1411016e6edeb26b012f',
        email: 'MIKE@hikvision.com.cn',
        firstName: 'MIKE',
        lastName: ' ',
        imageUrl: '',
        userType: '1',
        sessionId: 'd7972d8b-e80d-42eb-b3ad-6b1a5a25b3b5',
        permissions: ['0', '1', '2', '3', '4', '5', '6'],
        regionCode: 'EU_WEST_1',
        companyInfoImproved: '1',
        phone: '0-43-2233456',
        juridicalPersonFlag: true,
        roleId: 'defaultadministratorrole',
        companyId: 'ff8080816e6e1411016e6edee4330131',
        country: '1',
        firstLogin: false,
        orderStatus: {
          employee: {
            type: 'firstbuy'
          },
          maintenance: {
            type: 'firstbuy'
          }
        },
        grayscaleFunctions: [4]
      };
      data.touristModeUseType = 'register';
      data.registerData = this.registerForm;
      if (typeof countryIndex !== 'undefined') {
        data.registerData.country = countryIndex;
        data.country = countryIndex;
      }
      // 当页面因为JSESSIONID失效而返回登陆页面时，需要清除存下来的登陆跳转地址
      sessionStorage.removeItem('goUrl'); //落地页不引入组件
      sessionStorage.setItem('notLogUserInfo', JSON.stringify(data));
      window.location.href = `${window.location.origin }?hpcAfterLogin=true`;
    },
    resetForm() {
      this.$refs.registerForm.resetFields();
      this.verifyErrorTxt = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.account-register-check-email {
  ::v-deep .el-form-item__required {
    display: none !important;
  }
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 55px;
  .register-form {
    .code-button {
      font-size: 14px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .code-input {
      ::v-deep .el-input__inner {
        max-width: 245px;
      }
    }
     ::v-deep .el-form-item__label {
      width: 24px !important;
     }
    .login-code-input {
      width: 180px;
    }

    .login-code-pic {
      position: absolute;
      right: 0px;
      top: -9px;
      width: 152px;
      height: 40px;
      cursor: pointer;
    }
  }
  .special-country {
    .text {
      vertical-align: middle;
      line-height: 24px;
    }
  }
  .mt {
    margin-top: 100px;
  }
  .send-code-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    letter-spacing: 0;
  }
  .already-send {
    margin-bottom: 50px;
  }
  .nafr {
    font-size: 12px;
    color: #fa3239;
    letter-spacing: 0;
    line-height: 14px;
    margin-left: 24px;
  }
}
</style>
